"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// const PagerAnimator = (children, active) => {
//   const el = React.Children.toArray(children).find(
//     r => r.props.name === active
//   );
//   if (!el) return null;
//   return cloneElement(el);
// };
exports.ScrollAnimator = function (children, active) {
    react_1.useEffect(function () {
        window.location.hash = active;
    }, [active]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.AnimationGroup = function (_a) {
    var children = _a.children, _b = _a.active, active = _b === void 0 ? undefined : _b;
    //return animator(children, active);
    return children;
};
exports.AnimationGroup.displayName = "AnimationGroup";
